var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.25C5.1773 0.25215 3.42987 0.977169 2.14102 2.26602C0.852173 3.55486 0.127155 5.3023 0.125004 7.125C0.123328 8.61443 0.609821 10.0634 1.51 11.25C1.51 11.25 1.6975 11.4969 1.72813 11.5325L7 17.75L12.2744 11.5294C12.3019 11.4963 12.49 11.25 12.49 11.25L12.4906 11.2481C13.3902 10.0619 13.8764 8.61372 13.875 7.125C13.8729 5.3023 13.1478 3.55486 11.859 2.26602C10.5701 0.977169 8.82271 0.25215 7 0.25ZM7 9.625C6.50555 9.625 6.0222 9.47838 5.61108 9.20367C5.19996 8.92897 4.87952 8.53852 4.6903 8.08171C4.50109 7.62489 4.45158 7.12223 4.54804 6.63727C4.6445 6.15232 4.88261 5.70686 5.23224 5.35723C5.58187 5.0076 6.02733 4.7695 6.51228 4.67304C6.99723 4.57657 7.4999 4.62608 7.95671 4.8153C8.41353 5.00452 8.80397 5.32495 9.07868 5.73607C9.35338 6.1472 9.5 6.63055 9.5 7.125C9.49918 7.78779 9.23552 8.42319 8.76686 8.89185C8.29819 9.36052 7.66279 9.62417 7 9.625Z",
    fill: "#434343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationFilled);
export default __webpack_public_path__ + "static/media/locationFilled.9e5c976fec6b778e63b4b1c5d0ce7675.svg";
export { ForwardRef as ReactComponent };